<template>
  <div class="page">
    <div class="bg-wrap">
      <!-- 背景 +「选择认证方式」文案为同一张图 -->
      <img
        class="bg-img"
        src="@/assets/auth-method/bg-hero.png"
        alt=""
      />
      <img
        class="mascot"
        src="@/assets/auth-method/mascot.png"
        alt=""
      />

      <div class="content">
        <!-- 认证方式一：口令认证 -->
        <div class="card">
          <div class="card-head">
            <img
              class="card-icon"
              src="@/assets/auth-method/icon-passphrase.png"
              alt=""
            />
            <span class="card-title">认证方式一：口令认证</span>
          </div>
          <div class="card-row">
            <div class="card-value">
              <span>认证口令:</span>
              <span>{{ displayShareCode }}</span>
            </div>
            <div
              class="card-action"
              :class="{ disabled: !shareCode }"
              @click="copyShareCode"
            >
              复制
            </div>
          </div>
          <p class="card-tip">说明:复制口令后再打开支付宝App进行相关认证</p>
        </div>

        <!-- 认证方式二：打开链接 -->
        <div class="card">
          <div class="card-head">
            <img
              class="card-icon"
              src="@/assets/auth-method/icon-link.png"
              alt=""
            />
            <span class="card-title">认证方式二：打开链接</span>
          </div>
          <div class="card-row">
            <div class="card-value">
              <span>认证链接:</span>
              <span>{{ displaySignUrl }}</span>
            </div>
            <div
              class="card-action"
              :class="{ disabled: !signUrl }"
              @click="openSignUrl"
            >
              打开
            </div>
          </div>
          <p class="card-tip">说明:请在浏览器环境内打开链接进行相关认证</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'

export default {
  name: 'EnterpriseCodeAuthMethod',
  data() {
    return {
      signUrl: '',
      shareCode: '',
      employeeId: '',
      employeeNo: ''
    }
  },
  computed: {
    displayShareCode() {
      return this.shareCode || '暂无'
    },
    displaySignUrl() {
      if (!this.signUrl) return '暂无'
      return this.signUrl.length > 18
        ? `${this.signUrl.slice(0, 18)}...`
        : this.signUrl
    }
  },
  created() {
    document.title = '认证方式'
    try {
      const raw = sessionStorage.getItem('enterpriseCodeAuthResult')
      if (raw) {
        const data = JSON.parse(raw)
        this.signUrl = data.signUrl || ''
        this.shareCode = data.shareCode || ''
        this.employeeId = data.employeeId || ''
        this.employeeNo = data.employeeNo || ''
      }
    } catch (e) {
      // ignore
    }
  },
  methods: {
    openSignUrl() {
      if (!this.signUrl) {
        Toast('暂无认证链接')
        return
      }
      window.location.href = this.signUrl
    },
    copyShareCode() {
      if (!this.shareCode) {
        Toast('暂无认证口令')
        return
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(this.shareCode).then(
          () => Toast.success('已复制'),
          () => this.fallbackCopy(this.shareCode)
        )
      } else {
        this.fallbackCopy(this.shareCode)
      }
    },
    fallbackCopy(text) {
      const input = document.createElement('input')
      input.value = text
      document.body.appendChild(input)
      input.select()
      try {
        document.execCommand('copy')
        Toast.success('已复制')
      } catch (e) {
        Toast('复制失败，请手动复制')
      }
      document.body.removeChild(input)
    }
  }
}
</script>

<style lang="less" scoped>
/* 本项目 rootValue=75，样式按 750 设计稿书写（375 视觉尺寸 ×2） */
/* 内容区距图顶 445/1454 */
@content-top: 30.6%;
@side: 5.33%; /* 40/750 */

.page {
  min-height: 100vh;
  width: 100%;
  background-color: #9ae3ff;
  overflow-x: hidden;
}

.bg-wrap {
  position: relative;
  width: 100%;
}

.bg-img {
  display: block;
  width: 100%;
  height: auto;
  vertical-align: top;
  pointer-events: none;
  user-select: none;
}

.mascot {
  position: absolute;
  left: 38.67%; /* 290/750 */
  top: 20.9%; /* 304/1454 */
  width: 22.93%; /* 172/750 */
  height: auto;
  z-index: 2;
  pointer-events: none;
}

.content {
  position: absolute;
  left: 0;
  right: 0;
  top: @content-top;
  padding: 0 @side 80px;
  box-sizing: border-box;
  z-index: 1;
}

.card {
  background-color: rgba(232, 243, 254, 1);
  border-radius: 30px;
  padding: 30px 30px 40px;
  margin-bottom: 30px;
  box-sizing: border-box;
}

.card-head {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
}

.card-icon {
  width: 86px;
  height: 86px;
  margin-right: 22px;
  flex-shrink: 0;
}

.card-title {
  color: rgba(1, 1, 1, 1);
  font-size: 32px;
  font-weight: 700;
  line-height: 34px;
}

.card-row {
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 20px;
  height: 120px;
  padding: 0 20px 0 26px;
  box-sizing: border-box;
}

.card-value {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: rgba(60, 62, 75, 1);
  font-size: 28px;
  font-weight: 500;
  line-height: 34px;
}

.card-action {
  flex-shrink: 0;
  width: 170px;
  height: 72px;
  margin-left: 20px;
  line-height: 72px;
  text-align: center;
  background-color: rgba(33, 127, 255, 1);
  border-radius: 14px;
  color: #fff;
  font-size: 32px;
  font-weight: 500;

  &.disabled {
    opacity: 0.5;
  }
}

.card-tip {
  margin: 30px 0 0 10px;
  color: rgba(136, 143, 161, 1);
  font-size: 26px;
  line-height: 34px;
}
</style>
